var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus3536(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.02 35.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "minus-1",
    x: 0,
    y: 14.63,
    width: 35.02,
    height: 5.77,
    rx: 2.88,
    ry: 2.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus3536);
export default __webpack_public_path__ + "static/media/minus-35-36.52b6858f56e033c46436a49749b0a7b7.svg";
export { ForwardRef as ReactComponent };